export default __webpack_public_path__ + "static/media/Lakehead University.bd4092b6.png";